// extracted by mini-css-extract-plugin
export default {"Container":"Poster_Container__dSKyN","wrapper":"Poster_wrapper__rcvZV","poster_1":"Poster_poster_1__onFhD"};